import { IdentityProviders } from '../../../../interfaces/src/lib/identity-providers.interface';
import * as firebase from "firebase";

export function getIdentityProviders() {
  return {
    [firebase.auth.GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD]: 'google',
    [firebase.auth.FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD]: 'facebook',
    [firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD]: 'password',
    [firebase.auth.PhoneAuthProvider.PHONE_SIGN_IN_METHOD]: 'phone'
  };
}

export function mapIdentityProviders(authData: firebase.User): IdentityProviders {
    const providers = authData.providerData.reduce((prev, current) => {
      const key = getIdentityProviders()[current.providerId];
      if (key) {
        prev[key] = true;
      }
      return prev;
    }, {});
    return providers;
}